import { render, staticRenderFns } from "./PrimaryNavItem.vue?vue&type=template&id=1a9946a0&scoped=true&"
import script from "./PrimaryNavItem.vue?vue&type=script&lang=js&"
export * from "./PrimaryNavItem.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryNavItem.vue?vue&type=style&index=0&id=1a9946a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9946a0",
  null
  
)

export default component.exports